import { getAnalytics } from "firebase/analytics";
import { initializeApp } from "firebase/app";
import {
    connectAuthEmulator,
    GoogleAuthProvider,
    getAuth,
    signInWithRedirect,
} from "firebase/auth";
import { connectFirestoreEmulator, getFirestore } from "firebase/firestore";
import { connectFunctionsEmulator, getFunctions } from "firebase/functions";
import { fetchAndActivate, getBoolean, getRemoteConfig } from "firebase/remote-config";
import { connectStorageEmulator, getStorage } from "firebase/storage";
import {
    localDefaultRemoteConfig,
    type RemoteConfigKey,
} from "./common/localRemoteConfig";
import { firebaseAppConfig } from "./config";

export const firebase = initializeApp(firebaseAppConfig);
export const db = getFirestore();
export const auth = getAuth();
export const storage = getStorage();
export const functions = getFunctions(firebase, "europe-west1");
export const remoteConfig = getRemoteConfig();
export const analytics = getAnalytics(firebase);

const fetchRemoteConfigsEvery10minutes = 10 * 60 * 1000;
remoteConfig.settings.minimumFetchIntervalMillis = fetchRemoteConfigsEvery10minutes;

export const isLocalDevelopmentEnvironment = import.meta.env.REACT_APP_LOCAL === "true";

export const isProductionEnvironment =
    import.meta.env.REACT_APP_FIREBASE_PROJECT_ID === "albertine-prod";

if (isLocalDevelopmentEnvironment) {
    connectFirestoreEmulator(db, "localhost", 8080);
    connectStorageEmulator(storage, "localhost", 9199);
    connectFunctionsEmulator(functions, "localhost", 5001);
    connectAuthEmulator(auth, "http://localhost:9099", {
        disableWarnings: true,
    });

    remoteConfig.defaultConfig = localDefaultRemoteConfig;
} else {
    fetchAndActivate(remoteConfig).catch((error: unknown) => {
        console.error(error);
    });
}

export function getRemoteConfigValue(value: RemoteConfigKey): boolean | undefined {
    return getBoolean(remoteConfig, value);
}

export async function signInWithGoogle() {
    const googleProvider = new GoogleAuthProvider();
    googleProvider.setCustomParameters({
        prompt: "select_account",
    });
    try {
        const res = await signInWithRedirect(auth, googleProvider);
        const { user } = res;

        if (user) console.log("Logged in successfully!", user);
    } catch (error) {
        console.error(error);
        alert((error as Error).message);
    }
}

export function signOut() {
    void auth.signOut();
}
